import React, { Component } from 'react';
import {
  Stage,
  Layer,
  Line,
  Rect,
  RegularPolygon,
  Group,
  Text,
} from 'react-konva';

import ReactDOM from 'react-dom';
import Konva from 'konva';

class DrawShapeswithTextField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.selectedanswer,
      windowWidth: window.innerWidth,
      height: 200,
      width: 400,
    };
    console.log(window.innerWidth);

    this.handleChange = this.handleChange.bind(this);
  }

  handleResize = (e) => {
    this.setState({ windowWidth: window.innerWidth });
    console.log(window.innerWidth);
    console.log('1/3');
    console.log(window.innerWidth / 3);
  };

  handleChange(event) {
    this.setState({ value: event.target.value });
    this.props.selected(event.target.value, '1');
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.addEventListener('resize', this.handleResize);
  }

  selectedanswer = (answer, id) => {
    //////console.log(answer)
    // ////console.log(id)

    this.props.selected(answer, id);
  };

  render() {
    var rect = new Konva.Rect({
      x: 10,
      y: 20,
      width: 10,
      height: 10,
      fill: 'black',
      draggable: 'true',
    });

    return (
      <div className="questionBox">
        <div className="questions">
          {this.props.questionnumber + ')           ' + this.props.question}
        </div>

        <div className="centeranswer" align="center">
          <Stage width={this.state.windowWidth} height={280} align="center">
            <Layer>
              {/* <Line closed points={[0, this.state.height , this.state.width, 200, 0, 0]} x={this.state.windowWidth/5} y={50} fill="orange" />  */}
              <Rect
                x={this.state.windowWidth / 5}
                y={50}
                width={this.state.width}
                height={this.state.height}
                fill="orange"
                shadowBlur={5}
              />

              <Text
                fontSize={10}
                text="20 cm"
                x={this.state.windowWidth / 5}
                y={50 + this.state.height / 2}
                stroke="#fff"
                strokeWidth={1}
                align="center"
                rotation={-90}
              />

              <Text
                fontSize={10}
                text="20 cm"
                x={this.state.windowWidth / 5 + this.state.width / 2}
                y={40 + this.state.height}
                stroke="#fff"
                strokeWidth={1}
                align="center"
              />
            </Layer>
          </Stage>

          <br></br>
          <div>
            <input
              id={this.props.id}
              type="text"
              spellCheck="false"
              autoComplete="off"
              value={this.state.value}
              onChange={this.handleChange}
              placeholder="Enter answer here ..."

              //onChange={this.selectedanswer('name',this.props.id)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DrawShapeswithTextField;
